import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useHistory } from 'react-router'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/styles'
import { AppBar, Button, IconButton, Toolbar, Hidden, colors } from '@material-ui/core'
import InputIcon from '@material-ui/icons/Input'
import MenuIcon from '@material-ui/icons/Menu'

import { withStore } from 'src/store'
import { isDev } from 'src/constants'

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1,
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit',
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit',
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
  },
  searchPopperContent: {
    marginTop: theme.spacing(1),
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900],
    },
  },
  trialIcon: {
    marginRight: theme.spacing(1),
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  chatButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600],
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  logo: {
    fontFamily: "'Play', sans-serif",
    fontWeight: 700,
    color: '#fff',
    fontSize: '22px',
  },
}))

function TopBar({ onOpenNavBarMobile, className, logout, ...rest }) {
  const classes = useStyles()
  const history = useHistory()

  const handleLogout = () => {
    logout()
    history.push('/auth/login')
  }

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color={isDev ? 'secondary' : 'primary'}
    >
      <Toolbar>
        <Hidden lgUp>
          <IconButton className={classes.menuButton} color="inherit" onClick={onOpenNavBarMobile}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/" className={classes.logo}>
          {isDev ? 'Qubl Development' : 'Qubl'}
        </RouterLink>
        <div className={classes.flexGrow} />
        <Button className={classes.logoutButton} color="inherit" onClick={handleLogout}>
          <InputIcon className={classes.logoutIcon} />
          Sign out
        </Button>
      </Toolbar>
    </AppBar>
  )
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
  logout: PropTypes.func,
}

export default withStore(undefined, ({ session: { logout } }) => ({ logout }))(TopBar)
